/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Format_P2Inputs */

const en_wc_tut_format_p2 = /** @type {(inputs: Wc_Tut_Format_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For headings, use Styles instead of manual formatting: click in a paragraph and choose Heading 1, Heading 2 or Title in the Styles gallery. Hovering previews the style live. Headings then appear in the Navigation pane and in your table of contents.`)
};

/**
* | output |
* | --- |
* | "For headings, use Styles instead of manual formatting: click in a paragraph and choose Heading 1, Heading 2 or Title in the Styles gallery. Hovering previews..." |
*
* @param {Wc_Tut_Format_P2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_format_p2 = /** @type {((inputs?: Wc_Tut_Format_P2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Format_P2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_format_p2(inputs)
});
export { wc_tut_format_p2 as "wc.tut.format.p2" }